import { Component, Input } from '@angular/core';

@Component({
  selector: 'wre-field-history-data-table',
  templateUrl: './field-history-data-table.component.html',
  styleUrls: ['./field-history-data-table.component.sass']
})
export class FieldHistoryDataTableComponent {

  @Input() list = [];
  @Input() isAddedorRemoved = true;
  @Input() fieldType;
  offset = '0';
  hideCol = false;
}

